import "./SkeletonElement.css";

function SkeletonElement({ type, barHeight }) {
  const classes = `skeleton__element ${type}`;
  return <div className={classes} style={{ height: ` ${barHeight}` }}></div>;
}

export default SkeletonElement;
